import { cn } from '@/lib/utils';
import { forwardRef } from 'react';
import { Platform, TextInput, type TextInputProps } from 'react-native';

const Textarea = forwardRef<TextInput, TextInputProps>(function Textarea(
  { className, ...props },
  ref
) {
  return (
    <TextInput
      ref={ref}
      multiline
      textAlignVertical="top"
      className={cn(
        'border-input bg-background text-foreground min-h-24 w-full rounded-md border px-3 py-2 text-base leading-5 shadow-sm shadow-black/5',
        props.editable === false && 'opacity-50',
        Platform.select({
          web: 'outline-none transition-[color,box-shadow] focus:border-ring focus:ring-[3px] focus:ring-ring/50',
        }),
        className
      )}
      {...props}
    />
  );
});

export { Textarea };
